const backendUrl = 'https://gabriel-vallone-back.herokuapp.com/';

export default backendUrl;
